import React from 'react';

const Quote = () => (
  <div className="content-container">
    <blockquote>
      <p className="quote">
        &quot;If you know you are on the right track,
        if you have this inner knowledge, then nobody can turn you off...
        no matter what they say.&quot;
      </p>
      <cite>&#8212; Barbara McClintock</cite>
    </blockquote>
  </div>
);

export default Quote;
